export const PERMISSIONS = {
  USERS_VIEW: 'users.view',
  USERS_CREATE: 'users.create',
  USERS_UPDATE: 'users.update',
  USERS_DELETE: 'users.delete',
  ROLES_MANAGE: 'roles.manage',
  PRODUCTS_VIEW: 'products.view',
  PRODUCTS_MANAGE: 'products.manage',
  ORDERS_VIEW: 'orders.view',
  ORDERS_MANAGE: 'orders.manage',
  SETTINGS_MANAGE: 'settings.manage',
  MERCHANTS_VIEW: 'merchants.view',
  MERCHANTS_UPDATE_STATUS: 'merchants.update',
  MERCHANTS_SUSPEND: 'merchants.suspend',
  MERCHANTS_RESET_PASSWORD: 'merchants.update',
  LOCATIONS_VIEW: 'locations.view',
  LOCATIONS_MANAGE: 'locations.manage',
  INDUSTRIES_VIEW: 'industries.view',
  INDUSTRIES_MANAGE: 'industries.manage',
  PLANS_VIEW: 'plans.view',
  PLANS_CREATE: 'plans.create',
  PLANS_UPDATE: 'plans.update',
  PLANS_DEACTIVATE: 'plans.deactivate',
  SUBSCRIPTIONS_VIEW: 'subscriptions.view',
  STORES_VIEW: 'stores.view',
  STORES_UPDATE_STATUS: 'stores.update',
} as const

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]

export const ALL_PERMISSIONS: Permission[] = Object.values(PERMISSIONS)
